import React from 'react';
import './UsageIndicator.css';

export default function UsageIndicator({ usage }) {
  if (!usage) return null;

  const { total_prompts_used, quota_prompts, overage_prompts, overage_cost_cents } = usage;

  // Legacy PAYG users — show usage count and cost, no progress bar.
  if (!quota_prompts) {
    const cost = overage_cost_cents || 0;
    return (
      <div className="usage-indicator payg">
        <div className="usage-details">
          <span className="usage-count">
            {total_prompts_used} {total_prompts_used === 1 ? 'prompt' : 'prompts'} used this period
          </span>
          <span className="usage-cost-line">
            <strong>${(cost / 100).toFixed(2)}</strong> total charges
          </span>
        </div>
      </div>
    );
  }

  const pct = Math.min((total_prompts_used / quota_prompts) * 100, 100);
  const isOverage = total_prompts_used >= quota_prompts;
  const isWarning = pct >= 80 && !isOverage;

  let status = 'normal';
  if (isOverage) status = 'overage';
  else if (isWarning) status = 'warning';

  const remaining = Math.max(0, quota_prompts - total_prompts_used);

  return (
    <div className={`usage-indicator ${status}`}>
      <div className="usage-bar-track">
        <div
          className="usage-bar-fill"
          style={{ width: `${Math.min(pct, 100)}%` }}
        />
      </div>
      <div className="usage-details">
        <span className="usage-count">
          {total_prompts_used} of {quota_prompts} prompts used
        </span>
        {isOverage ? (
          <span className="usage-overage-line">
            {overage_prompts} overage {overage_prompts === 1 ? 'prompt' : 'prompts'} &middot;{' '}
            <strong>${(overage_cost_cents / 100).toFixed(2)}</strong> in overage charges
          </span>
        ) : isWarning ? (
          <span className="usage-warning-line">
            {remaining} {remaining === 1 ? 'prompt' : 'prompts'} remaining &mdash; overages billed at $0.25 each
          </span>
        ) : (
          <span className="usage-remaining-line">
            {remaining} {remaining === 1 ? 'prompt' : 'prompts'} remaining
          </span>
        )}
      </div>
    </div>
  );
}
